export default class HeaderClass {
  constructor(
    public id: string,
    public aboutUsTag: string,
    public industriesTag: string,
    public blogTag: string,
    public contactUsTag: string,
    public servicesTag: string,
  ) {}
}
